// extracted by mini-css-extract-plugin
export default {"highlight_wrapper":"Highlights_highlight_wrapper__CwteL"};